import axiosInstance from '../../../config/axiosInstance';
import { CustomerContactValidation } from "../View/Validation/CustomerContactValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
 event.preventDefault();
  const formErrors = CustomerContactValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      formData.formData.ClientID = CompanyID;
      const UserID = localStorage.getItem("UserID");
      formData.formData.UserID = UserID;
      
      const response = await axiosInstance.post(`/Customer/CreateCustomerContact`,formData);   
      localStorage.setItem('ClientContactID', response.data.ClientContactID);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };